// Contact form island (replaces the Angular contact-form.component). The footer modal markup
// is server-rendered (_SiteFooter); this drives the reCAPTCHA + submit to the existing
// /umbraco/surface/ContactSurface/PostSubmitContact endpoint.
//
// The captcha is rendered explicitly (its own widget id) so it does not clash with the chart-vote
// captcha that may also be present on chart pages.
//
// Registered as an Alpine.data component (used by _SiteFooter via x-data="contactForm()").
import { renderRecaptcha, recaptchaToken, resetRecaptcha } from './recaptcha.js';

export function registerContactForm(Alpine) {
  Alpine.data('contactForm', () => ({
    form: { name: '', email: '', message: '' },
    error: 0, // 0 = none, 'WrongRecaptcha', 'error'
    success: false,
    successMessage: '',
    submitting: false,
    widgetId: null,

    initCaptcha() {
      renderRecaptcha(this.$refs.captcha, (id) => { this.widgetId = id; });
    },

    async submit() {
      const token = recaptchaToken(this.widgetId);
      if (!token) { this.error = 'WrongRecaptcha'; return; }

      const subjectId = Number(this.$refs.subject ? this.$refs.subject.value : 0);
      if (!subjectId || !this.form.name || !this.form.email || !this.form.message) {
        this.error = 'error';
        return;
      }

      this.error = 0;
      this.submitting = true;
      try {
        const res = await fetch('/umbraco/surface/ContactSurface/PostSubmitContact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            subjectId,
            name: this.form.name,
            email: this.form.email,
            message: this.form.message,
            recaptchaResponse: token
          })
        });
        const data = await res.json();
        if (data.result === 'Success') {
          this.success = true;
          this.successMessage = data.message || '';
        } else {
          this.error = data.result === 'WrongRecaptcha' ? 'WrongRecaptcha' : 'error';
        }
      } catch (e) {
        console.error('[contactForm] submit failed', e);
        this.error = 'error';
      }
      this.submitting = false;
      resetRecaptcha(this.widgetId);
    }
  }));
}
